/* eslint-disable */ import { detailComponent, entityHeaderComponent, memoEval, staticPerspectiveCameraComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const leftThighBandComponents = [
    attachComponent.withComponent(staticPerspectiveCameraComponent, 'default', true).withEntity('LeftThighBand').withGradualFilter({
        selectedEntityIds: (self)=>self.id,
        viewStates: [
            'Default'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 2,
            fov: 35,
            near: 50,
            far: 2000,
            polarAngle: 1.5,
            minDistance: 300,
            maxDistance: 1000,
            lookAtY: -170,
            lookAtX: 70,
            azimuthAngle: 0.7,
            distance: 350
        }))),
    attachComponent.withComponent(detailComponent, 'default', true).withEntity('LeftThighBand').attach(memoEval(()=>[], ()=>({
            title: 'Left thigh band',
            subtitle: '',
            description: ''
        }))),
    attachComponent.withComponent(entityHeaderComponent, 'default', true).withEntity('LeftThighBand').attach(memoEval(()=>[], ()=>({})))
];

//# sourceMappingURL=left-thigh-band.js.map